/* eslint-disable import/no-cycle */
import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { addThemeUtils } from 'koddi-components/ThemeProvider';
import { initialState } from './reducer';

const selectApp = (state: ApplicationRootState) =>
    state.app.theme || initialState;

export const selectAppTheme = createSelector(selectApp, (state) => {
    return state.theme ? addThemeUtils(state.theme.theme) : undefined;
});

export const selectAppThemeResource = createSelector(
    selectApp,
    (state) => state.theme
);

export const selectAppThemeList = createSelector(
    selectApp,
    (state) => state.themes
);

export const selectThemeStatus = createSelector(
    selectApp,
    (state) => state.status
);

export const selectThemeError = createSelector(
    selectApp,
    (state) => state.error
);

export const selectThemeInitialized = createSelector(
    selectApp,
    (state) => state.initialized
);

export const selectThemeRegistration = createSelector(selectApp, (state) => {
    return state.registration_enabled;
});

export const selectThemeSSOIds = createSelector(selectApp, (state) => {
    return {
        sso_organization_id: state.sso_organization_id,
        sso_connection_id: state.sso_connection_id,
    };
});
